import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { useNavigate } from 'react-router';
import styles from './HomeHeader.module.css';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import gameAssets from '@themed-assets';
import usePlayerBalance from '@/src/hooks/data/usePlayerBalance';
import usePlatformCommunication from '@/src/hooks/utils/usePlatformCommunication';

const HomeHeader = ({ isVisible }) => {
  const playerBalance = usePlayerBalance();
  const navigate = useNavigate();
  const { addCashNavigation, walletNavigation } = usePlatformCommunication();

  const handleWalletNavigation = () => {
    walletNavigation()
  }

  const handleAddCash = () => {
    addCashNavigation()
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.header
          className={styles.homeHeader}
          initial={{ y: -100 }}
          animate={{ y: 0 }}
          exit={{ y: -100 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
        >
          <motion.div
            className={styles.headerContent}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            <motion.div
              className={styles.logoSection}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <img
                src={gameAssets.primaryLogo}
                alt="A23 Poker"
                className={styles.a23Logo}
              />
            </motion.div>

            <div className={styles.headerRight}>
              <motion.div
                className={styles.walletBalance}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.3 }}
              >
                <img style={{ height: '16px' }} src={gameAssets.wallet}></img>
                <span
                  onClick={handleWalletNavigation}
                  id='wallet-balance-span-home-header' className={styles.balanceAmount}>{RUPEE_SYMBOL + playerBalance.totalBalance}</span>
                <motion.button
                  id='add-cash-button-home-header'
                  className={styles.addCashBtn}
                  onClick={handleAddCash}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <span className={styles.plusIcon}>+</span>
                </motion.button>
              </motion.div>
            </div>
          </motion.div>
        </motion.header>
      )}
    </AnimatePresence>
  );
};

export default HomeHeader; 